import { DateTime } from 'luxon';
import * as buttons from 'smg/buttons';
import { CreateContact } from 'smg/customer-api/contact';
import * as quoteproofs from 'smg/customer-api/quoteproofs';
import * as revisions from 'smg/customer-api/revisions';
import { StoredMarker } from 'smg/customer-api/revisions/marker';
import { Revision } from 'smg/customer-api/revisions/revision';
import { Session } from 'smg/customer-api/session';
import { ReportValidity } from 'smg/form';
import * as html from 'smg/html';
import { UserEventUpload } from 'smg/models';
import { Phone } from 'smg/phone';
import { G } from 'smg/querystring';
import { Clone } from 'smg/template';
import * as toast from 'smg/toast';
import * as uploads from 'smg/uploads';
import * as util from 'smg/util';

export default async function main() {
    const sess = Session().catch(() => undefined);

    const spotNotesTemplate = document.querySelector('.spot-notes-label') as HTMLElement;
    spotNotesTemplate?.parentElement?.removeChild(spotNotesTemplate);
    const hasProofsContainer = document.querySelector('#has-proofs-container') as HTMLElement;
    const noProofsContainer = document.querySelector('#no-proofs-container') as HTMLElement;

    const resp = await quoteproofs.GetQuoteProofs();
    const { serial, quoteProofs, cloudFront } = resp.data;

    const quoteHash = G().Get('id');
    if (!quoteHash) {
        return;
    }

    const spinner = document.querySelector('#body-spinner') as HTMLElement;

    const container = document.querySelector('#proofs') as HTMLElement;
    if (quoteProofs?.length) {
        hasProofsContainer.classList.remove('d-none');
        let i = 0;
        for (const proof of quoteProofs) {
            const imgEl = document.createElement('img');
            imgEl.src = html.Escape(`${cloudFront}/${proof.proof?.file || ''}`);
            imgEl.alt = '';
            imgEl.style.maxWidth = '100%';
            const row = html.FromString(`
        <div id="${html.Escape(proof.id || '')}" class="row revisions-proof">
            <div id="proof-thumb-container" class="col-12 col-lg-8 pr-md-5 proof-col">
            </div>
            <div class="col-12 col-lg-4 notes">
                <form>
                    <div class="col-12 d-flex justify-content-between align-items-center">
                        <h3 class="proof-name">
                            Proof <span class="proof-number">${html.Escape(proof.number || '')}</span>
                        </h3>
                    </div>
                    <div class="col-12 marker-notes">
                        <p class="mb-6">
                            Click anywhere on your proof to add a comment
                        </p>
                    </div>
                    <div class="col-12 mb-3 d-flex justify-content-end">
                        <textarea id="general-notes" rows="5" class="form-control revision-notes rounded-0 col-11" placeholder="Any other comments are questions?"></textarea>
                    </div>
                    <div class="col-12">
                        <div class="d-flex justify-content-end">
                            <label class="btn btn-outline-primary mb-0 upload-button">
                                Upload Files
                                <input type="file" hidden multiple>
                            </label>
                            <button class="btn btn-primary submit-button ms-1 text-white">Submit</button>
                        </div>
                        <div class="uploads d-flex justify-content-end mt-3"></div>
                    </div>
                </form>
                <div class="row user-events"></div>
            </div>
        </div>`);

            const proofContainer = row.querySelector('#proof-thumb-container');
            proofContainer?.appendChild(imgEl);

            if (i++) {
                container.appendChild(document.createElement('hr'));
            }

            container.appendChild(row);

            const p = document.querySelector(`#${proof.id || ''}`) as HTMLElement;
            const c = p.querySelector('.proof-col') as HTMLElement;

            const form = row.querySelector('form') as HTMLFormElement;
            const thumbnails = form.querySelectorAll('.uploads')[0] as HTMLElement;
            const uploadBtn = form.querySelectorAll('.upload-button')[0] as HTMLLabelElement;
            const submit = form.querySelectorAll('.submit-button')[0] as HTMLButtonElement;
            const uploader = new uploads.Uploader(uploadBtn, {
                confirmBtn: submit,
                thumbnails,
            });
            const r = new Revision({
                proofID: proof.id || '',
                quoteHash,
                element: c,
                uploader,
            });

            const markerNotesWrapper = row.querySelector('.marker-notes') as HTMLElement;

            let userEventCount = 0;
            const exciteRequest = (userEventID: string, notes: string, date: DateTime, pointNumber?: number, userEventUploads?: UserEventUpload[]) => {
                if (!notes.length) {
                    return;
                }

                if (!userEventCount++) {
                    form.insertAdjacentHTML('afterend', '<div class="col-12 pb-3"><hr></div>');
                }

                const event = row.querySelector('.user-events') as HTMLElement;
                event.insertAdjacentHTML('beforeend', `
            <div class="col-12 pb-3 ml-auto${pointNumber ? html.Escape(' order-' + `${pointNumber}`) : ''}">
                <div class="pb-4 revision-request" id="${html.Escape(userEventID)}">
                    <div class="card border">
                        <div class="card-body d-flex">
                            <div class="revision-request-content flex-grow-1" style="min-width: 0;">${html.Nl2br(html.Escape(notes))}</div>
                            <a href="#" class="revision-request-cancel-link">
                                <i class="fa fa-trash"></i>
                            </a>
                        </div>
                        <div class="card-footer pt-0 bg-white border-0 revision-request-images"></div>
                        <div class="card-footer small text-muted bg-white border-0 pt-0">
                            Revision requested — <span class="revision-request-time">${date.toLocaleString(DateTime.DATETIME_SHORT)}</span>
                        </div>
                    </div>
                </div>
            </div>`);

                if (userEventUploads) {
                    const imgDiv = event.querySelector('.revision-request-images') as HTMLElement;
                    const uploadEls: HTMLElement[] = [];
                    for (const upload of userEventUploads) {
                        if (upload.upload) {
                            const a = Clone('.qrpt-upload').firstElementChild as HTMLAnchorElement;
                            a.setAttribute('data-name', upload.upload.name || '');
                            a.href = `${cloudFront}/${upload.upload.key || ''}`;
                            a.setAttribute('data-caption', upload.upload.name || '');
                            a.classList.add('qrpt-thumb');

                            uploadEls.push(a);
                            imgDiv.appendChild(a);
                        }
                    }
                    uploads.LoadAll(uploadEls);
                }

                const card = document.getElementById(userEventID);
                const cancelLink = card?.querySelector('a');

                cancelLink?.addEventListener('click', e => {
                    e.preventDefault();

                    revisions.DeleteRequest(quoteHash, userEventID).
                        then(() => {
                            const p = card?.parentElement;
                            p?.classList.add('d-none');

                            let m: StoredMarker | undefined;
                            if (pointNumber) {
                                m = r.GetMarker(pointNumber);
                                r.RemoveMarker(pointNumber);
                            }

                            const removeTimeout = setTimeout(() => p?.remove(), 15 * 1000);
                            const t = toast.Success(`Cancelled revision request <a href="#" class="toast-undo-link" data-user-event-project-task-id="${userEventID}">Undo</a>`);

                            const undo = document.querySelector(`.toast-undo-link[data-user-event-project-task-id="${userEventID}"]`) as HTMLElement;
                            undo.addEventListener('click', e => {
                                e.preventDefault();

                                t?.dispose();
                                clearTimeout(removeTimeout);

                                if (m) {
                                    if (pointNumber && m.position) {
                                        r.AddMarker(m.position, m.notes, true);
                                    }
                                }

                                void revisions.RestoreRequest(quoteHash, userEventID).
                                    then(() => p?.classList.remove('d-none'));
                            });
                        }).catch(err => {
                            toast.Error('Something went wrong!');
                            throw err;
                        });
                });
            };

            const drawSpotLabel = (n: number, text?: string): HTMLElement => {
                const label = spotNotesTemplate.cloneNode(true) as HTMLElement;

                const spotNumber = label.querySelector('.spot-notes-number') as HTMLElement;
                spotNumber.textContent = String(n);

                const textarea = label.querySelector('textarea') as HTMLTextAreaElement;
                textarea.placeholder = `Write a comment for spot ${n}`;

                textarea.addEventListener('focus', () => r.FocusMarker(n));
                textarea.addEventListener('focusout', () => r.RemoveFocus());
                if (text) {
                    textarea.value = text;
                }
                const debounce = util.Debounce(() => r.SetText(n, textarea.value), 300, false);
                textarea.addEventListener('input', () => debounce());

                const trashIcon = label.querySelector('.spot-notes-delete') as HTMLAnchorElement;
                trashIcon.addEventListener('click', e => {
                    e.preventDefault();
                    label.parentElement?.removeChild(label);
                    r.RemoveMarker(n);
                });

                return label;
            };

            r.OnMarkerAdd = m => {
                m.NotesEl = drawSpotLabel(r.LatestMarkerNumber(), m.GetNotes() || '');
                markerNotesWrapper.appendChild(m.NotesEl);

                setTimeout(() => {
                    const textarea = m.NotesEl?.querySelector('textarea') as HTMLTextAreaElement;
                    textarea.focus();
                });
            };

            const orderedUserEvents = proof.userEvents?.sort((a, b) => a.pointNumber || 0 - (b.pointNumber || 0));

            if (orderedUserEvents) {
                for (const userEvent of orderedUserEvents) {
                    if (userEvent.id && userEvent.content && userEvent.created) {
                        exciteRequest(userEvent.id, userEvent.content, DateTime.fromISO(userEvent.created), userEvent.pointNumber, userEvent.userEventUploads);
                    }
                    if (userEvent.point) {
                        r.AddMarker(userEvent.point, userEvent.content, true);
                    }
                }
            }

            r.LoadLocalStorage();

            r.OnMarkerRenumber = () => {
                let i = 1;
                for (const m of r.Markers) {
                    const oldNotesEl = m.NotesEl;
                    m.NotesEl = drawSpotLabel(i++, m.GetNotes());
                    if (oldNotesEl) {
                        markerNotesWrapper.replaceChild(m.NotesEl, oldNotesEl);
                    }
                }
            };

            const generalNotes = form.querySelector('#general-notes') as HTMLTextAreaElement;
            const generalNotesUpdate = util.Debounce(() => {
                r.GeneralNotes = generalNotes.value;
            }, 300, false);
            generalNotes.addEventListener('change', () => generalNotesUpdate());

            form.addEventListener('submit', e => {
                e.preventDefault();

                r.GeneralNotes = generalNotes.value;
                void r.Submit().
                    then(resp => {
                        r.ClearLocalStorage();
                        toast.Success('Revision request submitted!');

                        const unCommitted = r.Markers.filter(v => !v.Committed);
                        for (const m of r.Markers) {
                            m.Committed = true;
                        }

                        uploader.HideUploads();

                        const uIDs = resp.data.userEventIDs;

                        let i = 0;
                        for (const userEventID of uIDs) {
                            const m = unCommitted[i];
                            if (m) {
                                exciteRequest(userEventID, m.GetNotes(), DateTime.local());
                                m.UserEventID = userEventID;
                            } else if (r.GeneralNotes) {
                                exciteRequest(userEventID, r.GeneralNotes, DateTime.local());
                            }
                            i++;
                        }

                        const m = form.querySelectorAll('.marker-label');
                        m.forEach(mark => mark.remove());

                        generalNotes.value = '';
                    });
            });
        }
    } else {
        hasProofsContainer.classList.add('d-none');
        noProofsContainer.classList.remove('d-none');

        const noProofsRevisionsForm = document.querySelector('#no-proofs-revisions-form') as HTMLFormElement;
        const serialHeader = document.querySelector('#quote-number') as HTMLElement;
        const fullName = document.querySelector('#contact-full-name') as HTMLInputElement;
        const email = document.querySelector('#contact-email') as HTMLInputElement;
        const phone = document.querySelector('#contact-phone') as HTMLInputElement;
        const message = document.querySelector('#contact-message') as HTMLTextAreaElement;
        const uploadsLabel = document.querySelector('#uploads') as HTMLLabelElement;
        const submitBtn = document.querySelector('#contact-submit') as HTMLButtonElement;
        const requestSuccess = document.querySelector('#revision-success') as HTMLElement;

        serialHeader.textContent = serial;

        const p = new Phone(phone);

        await sess.then(sess => {
            if (sess) {
                fullName.value = `${sess.firstName} ${sess.lastName}`;
                email.value = sess.email;
                void p.Iti.promise.then(() =>
                    p.Iti.setNumber(sess.phone));
            }
        });

        const u = new uploads.Uploader(uploadsLabel, {
            confirmBtn: submitBtn,
            thumbnails: document.querySelector('#uploads-thumbnails') as HTMLElement,
        });

        noProofsRevisionsForm.noValidate = true;
        noProofsRevisionsForm.addEventListener('submit', e => {
            e.preventDefault();
            if (!ReportValidity(noProofsRevisionsForm)) {
                return false;
            }

            buttons.Start(submitBtn);

            CreateContact({
                name: fullName.value,
                company: '',
                phone: p,
                email: email.value,
                content: `Revision request for quote #${serial},

                        Customer Message:
                        ${message.value},`,
                uploader: u,
                $reCaptchaPlaceholder: document.querySelector('.contact-recpatcha-parent') as HTMLElement,
            }).then(() => {
                noProofsContainer.classList.add('d-none');
                requestSuccess.classList.remove('d-none');
                toast.Success('Request Sent!');
            }).catch(err => {
                toast.Error('Something went wrong!');
                throw err;
            }).finally(() => buttons.Stop(submitBtn));
        });
    }

    spinner.parentElement?.removeChild(spinner);
}